import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../Buttons/Button";
import { refundIpoSubscription } from "../../store/actions/ipos/refundIpoSubscription";
import { getCurrencySymbol } from "../../Helper/getCurrencySymbol";

const formatMoney = (currency, value) =>
  value != null
    ? `${getCurrencySymbol(currency)} ${Number(value).toLocaleString()}`
    : "-";

function RefundIpoSubscriptionModal({ open, onClose, subscription, ipoId }) {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.ipos?.refundPending);
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (open) {
      setReason("");
    }
  }, [open]);

  const handleRefund = () => {
    dispatch(
      refundIpoSubscription({
        subscriptionId: subscription?.id,
        ipoId,
        reason,
        callback: onClose,
      })
    );
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 480,
          maxWidth: "95vw",
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          p: 2,
        }}
      >
        <IconButton
          aria-label="close"
          sx={{ position: "absolute", top: 19, right: 10 }}
          onClick={onClose}
        >
          <ClearIcon />
        </IconButton>

        <div className="w-full p-3">
          <h1 className="font-semibold text-2xl mb-1">Refund Subscription</h1>
          <p className="text-sm mb-4 text-[#475467]">
            Cancels{" "}
            <span className="font-[600]">{subscription?.reference}</span> for{" "}
            <span className="font-[600]">
              {subscription?.user_name ||
                subscription?.user?.name ||
                `user #${subscription?.user_id}`}
            </span>{" "}
            and returns the full debit of{" "}
            <span className="font-[600]">
              {formatMoney(subscription?.currency, subscription?.total_debit)}
            </span>{" "}
            to their wallet — admin fee included.
          </p>

          <label className="text-sm font-[500]">Reason *</label>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Why is this subscription being refunded?"
            rows={3}
            className="w-full border border-[#D0D5DD] rounded-lg p-3 mt-1 mb-6 outline-none resize-none"
          />

          <div className="flex mt-2 w-full items-center">
            <CustomButton
              variant="outlined"
              customColor="#fff"
              children="Cancel"
              width="100%"
              height="44px"
              borderColor="#D0D5DD"
              color="#344054"
              margin="0px 25px 0px 0px"
              onClick={onClose}
            />
            <CustomButton
              variant="contained"
              customColor="#B42318"
              children="Refund"
              width="100%"
              height="44px"
              loading={loading}
              padding="10px"
              color="#fff"
              disabled={!reason.trim() || loading}
              onClick={handleRefund}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default RefundIpoSubscriptionModal;
